module.exports = __webpack_public_path__ + "img/1.e9810149.jpg";